var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirm",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShow,
          expression: "isShow"
        }
      ],
      attrs: {
        showMask: true,
        title: _vm.confirmTitle,
        closeIcon: true,
        close: _vm.close,
        leftBtnClick: _vm.cancelVIP,
        leftBtnTxt: _vm.confirmTitle,
        singleBtn: true,
        isLoading: _vm.isLoading
      }
    },
    [
      _c("div", { staticClass: "__row" }, [
        _c("div", { staticClass: "__row_t" }, [
          _vm._v(_vm._s(_vm.stakingText))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__input_row __unuse_input" }, [
          _vm._v(_vm._s(_vm.cancelItem ? _vm.cancelItem.amount : 0) + " dSLS")
        ])
      ]),
      _vm._v(" "),
      _vm.isSVip
        ? _c("div", { staticClass: "__hint" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("tradeVip.vipConfirm.adviseToCancel")))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "__hint" }, [
        _c("span", [_vm._v(_vm._s(_vm.hint))])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }